import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import React from 'react';
import { LicenseMetricsData } from '../../api/apis/OrgPricebookLicenseMetricsApi';
import { Svgs } from '../../assets/svg';
import PricebookRowLabel from '../../components/PricebookRowLabel';
import { PaymentTypeEnum, PricebookBundle } from '../../models/PricebookData';
import { getActivePrice } from '../../helpers/pricebookUtils';

interface OrgPaysMetricsCardProps {
  licenseMetric: LicenseMetricsData;
  onPurchaseLicenses: () => void;
  purchaseDisabled?: boolean;
  pricebookBundle?: PricebookBundle;
}

const OrgPaysMetricsCard: React.FC<OrgPaysMetricsCardProps> = ({
  licenseMetric,
  onPurchaseLicenses,
  purchaseDisabled,
  pricebookBundle,
}) => {
  const meteredPayment = licenseMetric.paymentType === PaymentTypeEnum.Metered;
  const selectedPrice = pricebookBundle?.prices
    ? getActivePrice(pricebookBundle.prices, { preferOneTime: true })
    : undefined;

  const licenseCounts = [
    { label: 'Licenses purchased', value: licenseMetric.purchasedLicenses ?? 0 },
    { label: 'Licenses remaining', value: licenseMetric.availableLicenses ?? 0 },
  ];

  return (
    <Card variant='ghost' color='secondary' className='pricebook-metric-card'>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              minWidth: 0,
              alignItems: 'center',
              gap: '10px',
            }}>
            <img
              src={licenseMetric.artUrl}
              alt='Package Logo'
              style={{ width: '30px', height: '30px', objectFit: 'contain', flexShrink: 0 }}
            />
            <PricebookRowLabel
              name={licenseMetric.pricebookName}
              price={selectedPrice}
              shortDescription={pricebookBundle?.pricebook.internalAdminDescription}
              metadata={pricebookBundle?.pricebook.metadata}
              truncate
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              minWidth: 0,
              alignItems: 'center',
              justifyContent: 'flex-end',
              ml: '16px',
              columnGap: { xs: '10px', md: '15px', xl: '40px' },
            }}>
            {licenseCounts.map(({ label, value }) => (
              <Box
                key={label}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  minWidth: 0,
                }}>
                <Typography variant='p12SemiBold' color='secondary' noWrap>
                  {label}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <Svgs.IconLicenseDefault style={{ flexShrink: 0 }} />
                  <Typography variant='p20SemiBold' color='secondary'>
                    {value}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
          {!meteredPayment && (
            <Button
              onClick={onPurchaseLicenses}
              disabled={purchaseDisabled}
              color='primary'
              sx={{
                ml: { xs: '20px', lg: '30px', xl: '50px' },
                px: { xs: '20px', lg: '40px' },
                fontSize: '16px',
                whiteSpace: 'nowrap',
                flexShrink: 0,
              }}>
              Edit licenses
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default OrgPaysMetricsCard;
